/**
 * Created by fan on 3/13/17.
 */
angular.module('smartorg.r6.cmpts.phoneNumber', []);
require('./phone-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.cmpts.phoneNumber';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/components/phone-number/app/js/plumbing/app.js